










import Vue from 'vue';
import loyalty from '@/store/modules/loyalty';
import cart from '@/store/modules/cart';
import device from '@/store/modules/device';
import giftcard from '@/store/modules/giftcard';
import { Component, Watch } from 'vue-property-decorator';
import { initState } from '@/store/stateinit';
import { Company } from '@/store/models';

@Component({})
export default class Loyalty extends Vue {
    public company: Company = initState('company');
    public purchasePoints: number = this.calculatePurchasePoints;
    public inAppPurchasePoints: number = this.calculateInAppPurchasePoints;

    get giftcardAmount() {
        return giftcard.giftcardSegment ? Math.abs(giftcard.giftcardSegment.value) : 0;
    }

    get cartSubtotal() {
        return cart.totals.subtotal_incl_tax;
    }

    get customerBenefits() {
        return loyalty.customerBenefits;
    }

    get hiddenBenefits() {
        return this.customerBenefits.filter((benefit) => !benefit.checkbox);
    }

    get totalPoints() {
        return (
            this.purchasePoints +
            this.inAppPurchasePoints +
            this.customerBenefits.reduce((acc, benefit) => (benefit.is_selected ? acc + +benefit.points : acc), 0)
        );
    }

    get calculatePurchasePoints() {
        if (loyalty.productPurchasePoints) {
            return Math.floor(
                Math.max(this.cartSubtotal - Math.abs(cart.totals.discount_amount) - this.giftcardAmount, 0) *
                    loyalty.productPurchasePoints,
            );
        }

        return 0;
    }

    get calculateInAppPurchasePoints() {
        if (loyalty.inAppProductPurchasePoints > 0 && device.isApp) {
            return loyalty.inAppProductPurchasePoints;
        }

        return 0;
    }

    get bannerTextTop() {
        if (loyalty.isSubscribed) {
            return this.$t('By completing this order you can earn {points}', {
                points: `<strong>${this.totalPoints} Passione Points</strong>`,
            });
        }

        return this.$t('If you are registered with the Passione Club, with this order you will get {points}', {
            points: `<strong>${this.totalPoints} Passione Points</strong>`,
        });
    }

    get bannerText() {
        let bannerText = '<ul>';
        bannerText += '<li>';
        bannerText += this.$t('{points} - completing order', {
            points: `<strong>${this.purchasePoints}</strong>`,
        });
        bannerText += '</li>';

        if (this.inAppPurchasePoints) {
            bannerText += '<li>';
            bannerText += this.$t('{points} - bonus for in-app purchase', {
                points: `<strong>${this.inAppPurchasePoints}</strong>`,
            });
            bannerText += '</li>';
        }

        if (this.hiddenBenefits.length) {
            this.hiddenBenefits.forEach((benefit) => {
                if (benefit.is_selected) {
                    bannerText += `<li><strong>${benefit.points}</strong> - ${benefit.name}</li>`;
                }
            });
        }

        bannerText += '</ul>';

        return bannerText;
    }

    get showBanner() {
        return this.totalPoints > 0 && (this.company.is_enabled ? this.company.is_loyalty_allowed : true);
    }

    @Watch('giftcardAmount')
    @Watch('cartSubtotal')
    public async updatePurchasePoints() {
        this.purchasePoints = this.calculatePurchasePoints;
        await loyalty.reloadLoyaltyBenefits(loyalty.isSubscribed);
    }
}
